import { Checkmark } from 'common/icons';
import {
  ButtonColor,
  PrimaryButton,
} from 'component-library/components/buttons/PrimaryButton';
import { Flex } from 'component-library/components/layout/Flex';
import { LinkWrapper } from 'component-library/components/links/LinkWrapper';
import { Body } from 'component-library/components/typography/Body';
import { Subheading } from 'component-library/components/typography/Subheading';
import React, { FC } from 'react';
import styled from 'styled-components';

const StyledCheckmark = styled(Checkmark)`
  margin-right: 10px;
`;

const StyledBody = styled(Body)`
  text-decoration: underline;
  cursor: pointer;
`;

const BULLET_POINT_COPY = [
  'Turn your savings into a reliable, recurring paycheck that lasts',
  'Add strategic tax monitoring to keep more of your savings',
  'Apply tax and timing best practices to every withdrawal',
  'Align with your lifestyle, healthcare, Social Security, and more',
];

interface PaycheckValuePropsProps {
  resetForm: () => void;
  retirementAge?: number;
  retirementSavings?: number;
  dateOfBirth?: string;
}

export const PaycheckValueProps: FC<PaycheckValuePropsProps> = ({
  resetForm,
  retirementAge,
  retirementSavings,
  dateOfBirth,
}) => (
  <>
    <Subheading variant={2} marginBottom={12}>
      Personalize your paycheck further for the full picture:
    </Subheading>
    {BULLET_POINT_COPY.map((point, idx) => (
      <Flex alignItems="center" marginBottom={4} key={idx}>
        <StyledCheckmark width="22px" height="22px" />
        <Body as="div" variant={3}>
          {point}
        </Body>
      </Flex>
    ))}
    <LinkWrapper
      to={`/welcome?utm_source=blog&utm_medium=calculator&utm_campaign=income&retirementSavings=${retirementSavings}&dateOfBirth=${dateOfBirth}&retirementAge=${retirementAge}`}
    >
      <PrimaryButton buttonColor={ButtonColor.Peach} marginTop={48}>
        Personalize Your Full Paycheck
      </PrimaryButton>
    </LinkWrapper>
    <Flex justifyContent="center">
      <StyledBody variant={4} onClick={resetForm}>
        Reset paycheck estimate
      </StyledBody>
    </Flex>
  </>
);
